// extracted by mini-css-extract-plugin
module.exports = {"mgt10":"mgt10_2k-mA","mgt20":"mgt20_wUw5E","mgt40":"mgt40_1JpxN","mgt60":"mgt60_2IvSc","mgt80":"mgt80_H8C7x","mgt100":"mgt100_2bbHP","footer":"footer_14jdY","icp":"icp_tWwb9"};